<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Z Report</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
  
        <user-z-report v-if="MultipleZendReports == 'Y'"></user-z-report>
        <general-z-report v-else></general-z-report>
       
      </v-card-text>
    </v-card>
  </v-container>
</template>
  
  <script>
import GeneralZReport from '../_components/general-z-report.vue';
import UserZReport from '../_components/user-z-report.vue';
export default {
  components: {
    GeneralZReport,
    UserZReport
  },
  data: () => ({
    MultipleZendReports: "",
  }),
  computed: {

  },
  methods: {
    getGenSettings() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.MultipleZendReports = res.ResponseData.MultipleZendReports;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getGenSettings()]);
  }
};
</script>